export const PaymentMethod = {
  QR_CODE: 'QR_CODE',
  PAY_WITH_WALLET: 'PAY_WITH_WALLET',
} as const

export type PaymentMethod = (typeof PaymentMethod)[keyof typeof PaymentMethod]

export const PaymentMethodFormValue = {
  QR_CODE_ONLY: 'QR_CODE',
  PAY_WITH_WALLET_ONLY: 'PAY_WITH_WALLET',
  BOTH: 'QR_CODE_AND_PAY_WITH_WALLET',
} as const

export type PaymentMethodFormValue =
  (typeof PaymentMethodFormValue)[keyof typeof PaymentMethodFormValue]

export const RemoteWalletProviderType = {
  CUSTODIAL: 'CUSTODIAL',
  SELF_CUSTODY: 'SELF_CUSTODY',
} as const

export type RemoteWalletProviderType =
  (typeof RemoteWalletProviderType)[keyof typeof RemoteWalletProviderType]

export interface HppPaymentMethodsResponse {
  types: PaymentMethod[]
}

export interface RemoteWalletProvider {
  id: string
  name: string
  logo: string
  type: RemoteWalletProviderType
  createdAt: string
  updatedAt: string
}

export interface RemoteWalletProviderItem {
  provider: RemoteWalletProvider
  enabled: boolean
}

export interface RemoteWalletProvidersResponse {
  totalElements: number
  content: RemoteWalletProviderItem[]
  pageable: {
    pageNumber: number
    pageSize: number
  }
}

export interface HppPaymentMethodsPayload {
  types: PaymentMethod[]
}

export interface RemoteWalletProviderAction {
  type: 'PROVIDER_ENABLEMENT'
  providerId: string
  enabled: boolean
}

export interface RemoteWalletProvidersPayload {
  ownerId: string
  actions: RemoteWalletProviderAction[]
}

export interface HppSettingsFormValues {
  paymentMethod: PaymentMethodFormValue
}
